import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useMovementOperationList = () => {
  const [loading, setLoading] = useState(false);
  const [movementOperationList, setMovementOperationList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getMovementOperationList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('Operation/Movement/List', {
        params: {
          Guid: params.Guid,
          Count: params.Count,
          Term: params.Term,
          Page: params.Page,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setMovementOperationList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              guid: element.guid,
              title: element.title,
              agentName: element.agentName,
              state: element.state,
              type: element.type,
              shortCode: element.shortCode,
              dateTime: element.dateTime,
              voucherTypeDisplay: element.voucherTypeDisplay,
              hasVoucher: element.hasVoucher,
            }));

            return { ...prev, [params?.Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return {
    getMovementOperationList,
    loading,
    movementOperationList,
    pageRef,
  };
};

export default useMovementOperationList;
